import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Stack, Typography } from '@mui/joy';
import cardImage from '../../images/red-card.webp';
import { useTranslation, getI18n } from 'react-i18next';
import api from '../../api/apiClient';
import { handleError } from '../../utils/error-handling';

function CardPossessionPage({ setNextPage }) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const handleYes = async () => {
    await api.post('/card/possession', {
      cardPossession: true,
    });
    navigate('/card-scan');
  };

  const handleNo = async () => {
    try {
      await api.post('/card/possession', {
        cardPossession: false,
      });
      setNextPage({
        route: '/thank-you',
        options: { state: { noCard: true } },
      });
    } catch (error) {
      handleError(
        'error',
        error.response?.data?.error[getI18n().language] ||
          error.response?.data?.error ||
          t('genericError')
      );
    }
  };

  return (
    <div className="p-4 flex flex-col items-center justify-center">
      <Stack direction="column" spacing={2}>
        <Typography level="h2" textAlign="center">
          {t('cardPossessionPage.title')}
        </Typography>
        <Typography level="body1" textAlign="center">
          {t('cardPossessionPage.description')}
        </Typography>
        <div className="flex justify-center">
          <img className="w-auto max-w-[300px]" src={cardImage} alt="Card" />
        </div>
        <Stack
          direction="row"
          spacing={2}
          className="flex justify-center w-full max-w-[350px] mx-auto"
        >
          <Button
            variant="soft"
            color="success"
            onClick={handleYes}
            className="flex-1 h-[70px]"
          >
            {t('cardPossessionPage.iHaveTheCard')}
          </Button>
          <Button
            variant="soft"
            color="danger"
            onClick={handleNo}
            className="flex-1 h-[70px]"
          >
            {t('cardPossessionPage.noLongerHasCard')}
          </Button>
        </Stack>
      </Stack>
    </div>
  );
}

export default CardPossessionPage;
